import './iframe_embed_creator.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';

import debounce from 'lodash/debounce';

import FormSimpleModal from 'zoomforth_component_lib/form_simple_modal.jsx';
import UrlInputContainer from 'zoomforth_component_lib/url_input_container.jsx';

import {
  makeUrlHttps,
  hasAnyError as hasAnyUrlError
} from 'zoomforth_zfutils/url_validators.js';

import sendPostRequest from 'zoomforth_zfutils/send_post_request.js';

import { LoadingIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

class IframeEmbedSectionCreator extends Component {

  constructor(props) {
    super(props);

    this.state = {
      url: props.url || '',
      checkingUrl: false,
      embedError: null,
      embedWarning: null
    };

    this.debouncedTryCheckIfCanEmbedUrl = debounce(this.tryCheckIfCanEmbedUrl, 500);

    autobind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  checkIfCanEmbedUrl() {
    this.setState({
      checkingUrl: true,
      embedError: null
    });

    const params = {
      url: makeUrlHttps(this.state.url)
    };

    const onSuccess = (resp) => {
      if (this.mounted) {
        if (resp.error) {
          this.setState({
            checkingUrl: false,
            embedError: resp.message
          });
        } else if (resp.warning) {
          this.setState({
            checkingUrl: false,
            embedWarning: resp.message
          });
        } else {
          this.setState({
            checkingUrl: false,
            embedError: null
          });
        }
      }
    };

    const onError = () => {
      if (this.mounted) {
        this.setState({
          checkingUrl: false,
          embedError: 'There was an error processing this URL. Please try again later.'
        });
      }
    };

    sendPostRequest('/rpc/check_iframe_embed_url_validity', params, onSuccess, onError);
  }

  tryCheckIfCanEmbedUrl() {
    if (!hasAnyUrlError(this.state.url)) {
      this.checkIfCanEmbedUrl();
    }
  }

  handleUrlChange(url) {
    this.setState({
      url: url,
      embedError: null,
      embedWarning: null
    });
    this.debouncedTryCheckIfCanEmbedUrl();
  }


  handleBlur() {
    this.debouncedTryCheckIfCanEmbedUrl.flush();
  }

  handlePaste() {
    this.debouncedTryCheckIfCanEmbedUrl.flush();
  }

  render() {
    const { saveButtonText, onSave, onCancel } = this.props;
    const { url, checkingUrl, embedError, embedWarning } = this.state;

    const shouldDisableConfirm = (
      checkingUrl ||
      embedError !== null ||
      hasAnyUrlError(url)
    );

    return (
      <FormSimpleModal
        style={{width:'500px'}}
        className="iframe-embed-section-creator"
        title="Type a URL to Embed"
        cancelText="Cancel"
        closeOnOuterClick={false}
        confirmText={checkingUrl ? <LoadingIcon /> : saveButtonText}
        confirmDisabled={shouldDisableConfirm}
        onCancel={()=> { onCancel(); } }
        onConfirm={() => {
          onSave(makeUrlHttps(url));
        }}
      >
        <p>Enter the URL of the content you would like to embed. For the best results, please use a URL which starts with HTTPS.</p>

        <UrlInputContainer 
          url={url} 
          focusOnMount={true}
          onUrlChange={this.handleUrlChange} 
          onBlur={this.handleBlur}
          onPaste={this.handlePaste}
        />

        {
          (embedError || embedWarning) &&
          <div className="embed-error">
            {embedError || embedWarning}
          </div>
        }

      </FormSimpleModal>
    );
  }
}

IframeEmbedSectionCreator.propTypes = {
  saveButtonText: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

IframeEmbedSectionCreator.defaultProps = {
  saveButtonText: 'Create Section'
};

export default IframeEmbedSectionCreator;
